import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Icon from "@mdi/react";
import { mdiPencil, mdiPlus } from "@mdi/js";
import In from "Resources/ImagesNew/print-alt-5-white.png";
import moment from "moment";
import { getBranch } from "utils/utils";

export const BtnInDanhSachRp = ({ }) => {
    const dispatch = useDispatch();
    const dataSearch = useSelector((state) => state.dataSearchDanhSachDonHang);

    const Print = () => {
        window.location.href =
            "/PrintsFile/ListDonHang?fromDate=" +
            moment(dataSearch.fromDate).format("YYYY-MM-DD") +
            "&toDate=" +
            moment(dataSearch.toDate).format("YYYY-MM-DD") +
            "&sSearch=" +
            dataSearch.sSearch +
            "&iTrangThaiThanhToan=" +
            dataSearch.iTrangThaiThanhToan
            ;
    };
    return (
        <>
            <button
                className="button-Icon-text bg-blue-main mr-2 button-in-new"
                onClick={Print}
            // disabled={doubleClick}
            >
                <img src={In} title="In" alt="" />
                In
            </button>
        </>
    );
};
